import { Component, type ErrorInfo, type ReactNode } from 'react'

import { BROWSER_ERROR_KEYS, instrumentBrowserError } from '@library/observability/browser'

type Props = {
  blockKey: string
  children: ReactNode
}

type State = { hasError: boolean }

// Per-block error boundary. Custom rather than InstrumentedErrorBoundary because we need
// blockKey in telemetry — the shared boundary only forwards { errorInfo }, so a failure
// would not say which CMS section crashed.
export class SafeBlock extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    instrumentBrowserError(
      BROWSER_ERROR_KEYS.CMS_BLOCK_RENDER_ERROR,
      { errorInfo, blockKey: this.props.blockKey },
      error,
    )
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return null
    }
    return this.props.children
  }
}
